import { FileWithPath } from '@mantine/dropzone';
import { z } from 'zod';

export const CREATE_CATEGORY_SCHEMA = z.object({
  title: z
    .string()
    .min(3, 'Минимальная длина 3 символа')
    .max(100, 'Максимальная длина 100 символов'),
  previewFile: z.custom<FileWithPath>(
    (value) => Boolean(value),
    'Обложка обязательна',
  ),
});
